
export default function actionModal(active) {
  return (dispatch) => {
    dispatch({        
      type: 'UTIL_MODAL',
      active: active
    })
  }
}